import { Flex, Text } from '@chakra-ui/react';
import { PropsWithChildren } from 'react';
import AvatarPaper from './AvatarPaper';

type EmailRowTitleProps = PropsWithChildren<{
  title: string;
}>

export default function EmailRowTitle({ title, children }: EmailRowTitleProps) {
  return (
    <Flex 
      alignItems="center"
      w="full"
      color="#525866"
      fontSize="12px"
      lineHeight="133.333%"
      sx={{
        strong: {
          display: 'block',
          color: '#0A0D14',
          fontSize: '14px',
          fontWeight: 500,
          lineHeight: '120%',
          letterSpacing: '-0.084px'
        }
      }}
    >
      <AvatarPaper />
    
      <Text as="span">
        <strong>{title}</strong>
      </Text>
      
      { children }
    </Flex>
  )
}
